import SectionTitle from "../components/SectionTitle";
import { FaGithub, FaLinkedin } from "react-icons/fa6";
// import { AiFillInstagram } from "react-icons/ai";
import { MdEmail } from "react-icons/md";
import { ReactTyped } from "react-typed";

export default function Contact() {
  return (
    <section
      id="Contact"
      className="lg:mx-auto mx-[10%] max-w-[1000px] my-5 text-justify flex lg:flex-row flex-col justify-between lg:gap-20 gap-10 h-full"
    >
      <div className="lg:w-[40%] w-full">
        <SectionTitle componentStyle={"sec-title"} text="Let's Get In Touch" />

        <p className="text-white">
          <ReactTyped
            strings={[
              "Did you enjoy viewing my works?",
              "Have collaboration ideas?",
              "Want to connect?",
            ]}
            loop
            smartBackspace
            showCursor
            typeSpeed={100}
            backSpeed={50}
          />{" "}
          <br /> <br />
          Feel free to reach out in any of my contacts below. I look forward to
          hearing from you.
        </p>
        <br />
        </div>
        <div className="contact-link-container">
          <a
            href="https://www.linkedin.com/in/renee-kh4n/"
            target="_blank"
            className="contact-link"
            rel="noopener noreferrer"
          >
            <FaLinkedin size={25} />
            <p className="my-auto select-text">
              https://www.linkedin.com/in/renee-kh4n/
            </p>
          </a>

          <a
            href="https://github.com/renee-kh4n"
            target="_blank"
            className="contact-link"
            rel="noopener noreferrer"
          >
            <FaGithub size={25} />
            <p className="my-auto select-text">https://github.com/renee-kh4n</p>
          </a>

          <a
            href="mailto:renee.a.f.khan@gmail.com"
            target="_blank"
            className="contact-link"
            rel="noopener noreferrer"
          >
            <MdEmail size={25} />
            <p className="my-auto select-text">renee.a.f.khan@gmail.com</p>
          </a>
        </div>
      {/* </div> */}
{/* 
      <div className="flex-1">
      </div> */}
    </section>
  );
}
